export const log = (text) => {
    console.log(text);
}

// Placeholder for event logging - will be replaced with Firebase Analytics in Phase 3
export const logEvent = (category, action, label, value, nonInteraction = false) => {
    // Temporary: Just log to console until Firebase Analytics is implemented
    log("logEvent = " + category + ", " + action + (", " + label || "") + (", " + value || "") + ", " + (", " + nonInteraction || "") + ", ")
}
